/**
 * Labstep
 *
 * @module components/OrganizationPlan/Action/OrganizationPlanActionOrganizationPlanActionBillingPortal
 * @desc   Open stripe portal
 */

import { StripeContainer } from 'labstep-web/containers/Stripe';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { windowService } from 'labstep-web/services/window.service';
import type React from 'react';

export const OrganizationPlanActionOrganizationPlanActionBillingPortal: React.FC =
  () => (
    <StripeContainer>
      {({
        createStripeBillingPortalSession,
        createBillingPortalSessionStatus,
      }) => (
        <ActionComponent
          type="button"
          status={createBillingPortalSessionStatus}
          onClick={() =>
            createStripeBillingPortalSession(
              {
                return_url: window.location.href,
              },
              {
                onSuccess: ({ response }) => {
                  windowService.setLocation(response!.url as string);
                },
              },
            )
          }
          elementProps={{
            basic: true,
          }}
          text="Edit Payment Method"
        />
      )}
    </StripeContainer>
  );
